// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10x03","top":"styles_top__1as2t"};